import { useState, useEffect } from 'react';
import { getVacancyMaintenance } from '@/lib/coloc-api/admin';
import { useQuery } from '@tanstack/react-query';
import { useColocApi } from '@/hooks/use-coloc-api';
import { useVacancyMaintenanceFiltersContext } from './use-vacancy-maintenance-filters';
import { useDebounce } from '@/hooks/use-debounce';
import React from 'react';

export const useVacancyMaintenance = () => {
  const {
    selectedVacancyHouse,
    selectedVacancyStatus,
    housesQuery,
  } = useVacancyMaintenanceFiltersContext();

  const {
    page,
    pageLimit,
    setPage,
    setPageLimit,
    setPaginationResponse,
  } = useColocApi();

  const debouncedHousesQuery = useDebounce(housesQuery, 500);

  const queryKey = [
    'vacancyMaintenance',
    selectedVacancyHouse?.id,
    selectedVacancyStatus,
    page,
    pageLimit,
    debouncedHousesQuery,
  ];

  const query = useQuery({
    queryKey,
    queryFn: () => getVacancyMaintenance({
      house_id: selectedVacancyHouse?.id,
      status: selectedVacancyStatus === 'all' ? undefined : selectedVacancyStatus,
      page,
      page_limit: pageLimit,
      query: debouncedHousesQuery || undefined,
    }),
    keepPreviousData: true,
  });

  React.useEffect(() => {
    if (query.data?.data.pagination) {
      setPaginationResponse({ pagination: query.data.data.pagination });
    }
  }, [query.data?.data.pagination, setPaginationResponse]);

  return {
    ...query,
    page,
    pageLimit,
    setPage,
    setPageLimit,
  };
}; 